import axiosInstance from "./authentication/axiosInstance";

export const taskServices = {
  // getTaskData: async (search, page, size, activePage, activeSize, activeSearch) => {
  //   const response = await axiosInstance.get(`/tasks/getAssignedTasks?search=${search}&pageNo=${page}&size=${size}&activePage=${activePage}&activeSize=${activeSize}&activeSearch=${activeSearch}`);
  //   return response.data;
  // },

  getTaskData: async (search, filter, page, size, activePage, activeSize, activeSearch, activeFilter, sortField, sortDirection, activeSortField, activeSortDirection) => {
    const params = new URLSearchParams({
      search: search || '',
      filter: filter || '',
      pageNo: page ?? 0,
      size: size ?? 10,
      activePage: activePage ?? 0,
      activeSize: activeSize ?? 5,
      activeSearch: activeSearch || '',
      activeFilter: activeFilter || '',
      sortField: sortField || 'updatedAt',
      sortDirection: sortDirection || 'desc',
      activeSortField: activeSortField || 'updatedAt',
      activeSortDirection: activeSortDirection || 'desc'
    }).toString();

    const response = await axiosInstance.get(`/tasks/getAssignedTasks?${params}`);
    return response.data;
  },

  getTaskDataById: async (taskId) => {
    const response = await axiosInstance.get(`/tasks/${taskId}`);
    return response.data;
  },

  // getCurrentJobsAssignedByUser: async (page, size, search, isTableShow) => {
  //   const response = await axiosInstance.get(`/tasks/assignedJob?pageNo=${page}&size=${size}&search=${search}&isTableShow=${isTableShow}`);
  //   return response.data;
  // },

  getCurrentJobsAssignedByUser: async (page, size, search, filter, isTableShow, sortField, sortDir) => {
    const params = new URLSearchParams({
      pageNo: page,
      size: size,
      search: search || '',
      filter: filter || '',
      isTableShow: isTableShow,
      sortField: sortField || 'updatedAt',
      sortDir: sortDir || 'desc'
    }).toString();

    const response = await axiosInstance.get(`/tasks/assignedJob?${params}`);
    return response.data;
  },

  // getCurrentJobsUnAssignedByUser: async (page, size, search, isTableShow) => {
  //   const response = await axiosInstance.get(`/tasks/unassignedJob?pageNo=${page}&size=${size}&search=${search}&isTableShow=${isTableShow}`);
  //   return response.data;
  // },

  getCurrentJobsUnAssignedByUser: async (page, size, search, filter, isTableShow, sortField, sortDir) => {
    const params = new URLSearchParams({
      pageNo: page,
      size: size,
      search: search || '',
      filter: filter || '',
      isTableShow: isTableShow,
      sortField: sortField || 'updatedAt',
      sortDir: sortDir || 'desc'
    }).toString();

    const response = await axiosInstance.get(`/tasks/unassignedJob?${params}`);
    return response.data;
  },

  postTaskData: async (newPost) => {
    const response = await axiosInstance.post("/tasks", newPost);
    return response.data;
  },

  postStartStopTask: async (newPost) => {
    const response = await axiosInstance.post("/tasks/startStop", newPost);
    return response.data;
  },

  deleteTaskData: async (taskId) => {
    const response = await axiosInstance.delete(`/tasks/${taskId}`);
    return response.data;
  },

  updateTaskData: async (formUpdate) => {
    const response = await axiosInstance.put("/tasks", formUpdate);
    return response.data;
  },

  updateJobStatus: async (newStatus) => {
    const response = await axiosInstance.post("/jobs/updateStatus", newStatus);
    return response.data;
  },

  getTaskTitles: async () => {
    const response = await axiosInstance.get("/users/taskTitles");
    return response.data;
  },

  // getAllExtraTasks: async (search, page, size, activePage, activeSize, activeSearch) => {
  //   const response = await axiosInstance.get(`/tasks/extraTasks?search=${search}&pageNo=${page}&size=${size}&activePage=${activePage}&activeSize=${activeSize}&activeSearch=${activeSearch}`);
  //   return response.data;
  // },

  getAllExtraTasks: async (search, filter, page, size, activePage, activeSize, activeSearch, activeFilter, sortField, sortDirection, activeSortField, activeSortDirection) => {
    const params = new URLSearchParams({
      search: search || '',
      filter: filter || '',
      pageNo: page ?? 0,
      size: size ?? 10,
      activePage: activePage ?? 0,
      activeSize: activeSize ?? 5,
      activeSearch: activeSearch || '',
      activeFilter: activeFilter || '',
      sortField: sortField || 'updatedAt',
      sortDirection: sortDirection || 'desc',
      activeSortField: activeSortField || 'updatedAt',
      activeSortDirection: activeSortDirection || 'desc'
    }).toString();

    const response = await axiosInstance.get(`/tasks/extraTasks?${params}`);
    return response.data;
  },

  getTotalTaskTimeDuration: async (taskId) => {
    const response = await axiosInstance.get(`/tasks/${taskId}/duration`);
    return response.data;
  },

  getAllSubTasksById: async (taskId) => {
    const response = await axiosInstance.get(`/tasks/${taskId}/allSubTasks`);
    return response.data;
  },
};
